import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/ur/Hero";
import { TrustBar } from "@/components/ur/TrustBar";
import { ServicesSection } from "@/components/ur/Services";
import { About } from "@/components/ur/About";
import { Projects } from "@/components/ur/Projects";
import { Calculators } from "@/components/ur/Calculators";
import { Pricing } from "@/components/ur/Pricing";
import { WhyChoose } from "@/components/ur/WhyChoose";
import { Gallery } from "@/components/ur/Gallery";
import { Blog } from "@/components/ur/Blog";
import { FAQ } from "@/components/ur/FAQ";
import { HowItWorks } from "@/components/ur/Process";
import { FinalCTA } from "@/components/ur/FinalCTA";

export const Home = () => {
  const loc = useLocation();
  useEffect(() => { if (!loc.hash) window.scrollTo({ top: 0 }); }, [loc]);
  return (
    <>
      <Hero />
      <TrustBar />
      <ServicesSection />
      <About />
      <Projects limit={6} />
      <Calculators />
      <Pricing />
      <WhyChoose />
      <Gallery />
      <Blog />
      <FAQ />
      <HowItWorks />
      <FinalCTA />
    </>
  );
};
